export default function() {
  return {
    measures: [],
    cycleTypes: [],
    cycleSegments: [],
    cycleBeads: []
  }
}
